import { IMedicine } from 'constants/types';

const setMedicinesInput: (
  medicines: IMedicine[],
) => IMedicinesInput | Object = (medicines) =>
  medicines != null && medicines.length > 0
    ? { medicines: medicines.map((p: any) => ({ id: p.id })) }
    : { medicines: [] };

export { setMedicinesInput };

interface IMedicinesInput {
  medicines: Array<{
    id: string;
  }>;
}
